export default {
    Get: {
        LIST_OF_PROPERTY_DESCRIPTIONS: 'getListOfPropertyDescriptions',
        GET_PROPERTY_DESCRIPTIONS:'getPropertyDescription'
    },
    Set: {
        LIST_OF_PROPERTY_DESCRIPTIONS: 'setListOfPropertyDescriptions',
        INSERT_PROPERTY_DESCRIPTIONS: 'insertPropertyDescriptions',
        UPDATE_PROPERTY_DESCRIPTION: 'updatePropertyDescription',
        DELETE_PROPERTY_DESCRIPTION: 'deletePropertyDescription',
    },
    Service: {
        LIST_OF_PROPERTY_DESCRIPTIONS: 'listOfPropertyDescriptions',
    },
};